import React from "react";
import ReactDOM from "react-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
  from,
  HttpLink,
  ApolloLink,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import tokenVar from "./vars/token";
import ThemeEffects from "./components/themeprovider";
import { ChakraProvider } from "@chakra-ui/react";
import { persistor, store } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { logoutUser } from "./features/loggedInUser.features";
import { logoutGuardianUser } from "./features/guardianUser.features";

// const httpLink = createHttpLink({
//   uri: "https://ribbonprotocol-staging.herokuapp.com/graphql",
// });

// const authLink = setContext((_, { headers }) => {
//   const token = tokenVar();
//   return {
//     headers: {
//       ...headers,
//       Authorization: token ? `Bearer ${token}` : "",
//     },
//   };
// });

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_BACKEND_GRAPHQL_URL ?? "",
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = tokenVar();

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  }));

  return forward(operation);
});

const logoutLink = onError(({ networkError }) => {
  console.log("hello - ", networkError);
  if (networkError?.message || networkError?.name) {
    // tokenVar("");
    // store.dispatch(logoutUser());
    // store.dispatch(logoutGuardianUser());
    // persistor.purge();
    // localStorage.clear();
  }
});

const client = new ApolloClient({
  link: from([authMiddleware, logoutLink.concat(httpLink)]),
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* @ts-ignore */}
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={client}>
          <ThemeEffects />
          <ChakraProvider>
            <App />
          </ChakraProvider>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
